import { Paperclip } from "lucide-react";

export type AttachmentRef = {
  fileId: number;
  fileName: string | null;
  /** "attach" = bảng ATTACH của vpdt (file văn bản ký / văn bản đến). */
  source?: "files" | "attach";
};

/**
 * Cột "File văn bản" / "File ký" của hệ cũ: bấm thẳng vào tên file trên dòng để
 * tải, không phải mở chi tiết rồi mới tải được.
 */
export function AttachmentCell({
  files,
  onOpen,
}: {
  files: AttachmentRef[] | null | undefined;
  onOpen: (f: AttachmentRef) => void;
}) {
  if (!files?.length) return <span className="text-muted-foreground">—</span>;
  return (
    <div className="flex flex-col gap-0.5">
      {files.map((f) => (
        <button
          key={f.fileId}
          type="button"
          title={f.fileName ?? `File #${f.fileId}`}
          onClick={(e) => {
            e.stopPropagation();
            onOpen(f);
          }}
          className="inline-flex items-center gap-1 text-primary-600 hover:underline text-xs max-w-[220px]"
        >
          <Paperclip className="h-3 w-3 shrink-0" />
          <span className="truncate">{f.fileName ?? `File #${f.fileId}`}</span>
        </button>
      ))}
    </div>
  );
}
